import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Chip,
  Grid,
  Card,
  CardMedia,
  CardContent
} from "@mui/material";

const TMDB_IMAGE_BASE = "https://image.tmdb.org/t/p/w500";

const isMedia = (str) =>
  typeof str === "string" &&
  (str.endsWith(".jpg") || str.endsWith(".png") || str.endsWith(".webp") || str.endsWith(".mp4"));

const renderOption = (option, index, correctAnswerIndex) => {
  const isCorrect = index === correctAnswerIndex;
  return (
    <Card
      key={index}
      variant="outlined"
      sx={{
        mb: 1,
        borderColor: isCorrect ? "green" : "grey.300",
        backgroundColor: isCorrect ? "green.50" : "white",
      }}
    >
      {isMedia(option) ? (
        <CardMedia
          component={option.endsWith(".mp4") ? "video" : "img"}
          src={TMDB_IMAGE_BASE+option.substring(option.indexOf("/")).trim()    //option.replace(/^.*?\)/, "").trim()
          }
          alt={`Option ${index}`}
          controls={option.endsWith(".mp4")}
          sx={{ height: 200, objectFit: "contain" }}
        />
      ) : (
        <CardContent>
          <Typography>{option}</Typography>
        </CardContent>
      )}
    </Card>
  );
};

const OpenAIQuestionDialog = ({ open, onClose, questions }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>Trivia Questions</DialogTitle>
      <DialogContent dividers>
        {Array.isArray(questions) && questions?.map((q, i) => (
          <Box key={q?.id} sx={{ mb: 4 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography variant="h6">
                Q{i + 1}.{" "}
                {isMedia(q?.question) ? (
                  <img
                    src={TMDB_IMAGE_BASE + q?.question}
                    alt="Question"
                    style={{ maxHeight: 200 }}
                  />
                ) : (
                  q?.question
                )}
              </Typography>
              <Chip label={q?.difficulty} color="primary" size="small" />
            </Box>

            <Grid container spacing={2}>
              {q?.options?.map((opt, idx) => (
                <Grid item xs={12} sm={6} key={idx}>
                  {renderOption(opt, idx, q?.correctAnswerIndex)}
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OpenAIQuestionDialog;
